import { useAuth } from '../contexts/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { user, loading, termsAccepted } = useAuth();
  const location = useLocation();
  const isTermsPage = location.pathname === '/terms';

  if (loading || termsAccepted === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Si no hay usuario, redirigir a auth
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Si el usuario no ha aceptado los términos y NO está en la página de términos, redirigir
  if (termsAccepted === false && !isTermsPage) {
    return <Navigate to="/terms" replace />;
  }

  return children;
};

export default ProtectedRoute;
